var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3333 12.2226C21.3333 7.12958 17.2294 3 12.1667 3C7.10483 3 3 7.12958 3 12.2226C3 16.8252 6.35225 20.6422 10.7348 21.3333V14.8883H8.40742V12.2226H10.7348V10.1903C10.7348 7.87942 12.1034 6.60342 14.1971 6.60342C15.1999 6.60342 16.2486 6.78308 16.2486 6.78308V9.05275H15.0927C13.9542 9.05275 13.5994 9.76317 13.5994 10.4928V12.2226H16.1413L15.7353 14.8883H13.5994V21.3333C17.982 20.6422 21.3333 16.8252 21.3333 12.2226Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.d5fd86e98b119c88d3ec67bc31eaf772.svg";
export { ForwardRef as ReactComponent };